import { createContext } from "react";
import MediaServicesSearchClient from "@foundation/media-services-search-client";
import { PersonalizationClient } from "@foundation/personalization";
import { SignInButtons, User } from "./types";

export interface NavContextProps {
    user?: User;
    personalizationClient?: PersonalizationClient;
    searchClient: MediaServicesSearchClient;
    initializeSignInWithRegUI: ({ desktopSignInButton, mobileSignInButton }: SignInButtons) => void;
    onSignOut: () => void;
    subscriptionUrl: string;
    upgradeUrl: string;
}

export const DEFAULT_CONTEXT_PROPS: NavContextProps = {
    user: undefined,
    personalizationClient: undefined,
    searchClient: new MediaServicesSearchClient(),
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    initializeSignInWithRegUI: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSignOut: () => {},
    subscriptionUrl: "https://www.bloomberg.com/subscriptions",
    upgradeUrl: "https://www.bloomberg.com/portal/subscription?triggerSubscriptionUpgradeModal=true",
};

export const NavContext = createContext<NavContextProps>(
    DEFAULT_CONTEXT_PROPS,
);
